import { render, staticRenderFns } from "./AssignationComposantesP4W.vue?vue&type=template&id=2204d03e"
import script from "./AssignationComposantesP4W.vue?vue&type=script&lang=js"
export * from "./AssignationComposantesP4W.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports